import { ErrorBoundary } from '@appsignal/react';
import { JSClient } from '@appsignal/types';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import type { JSX } from 'react';
import appsignal from '../../../appsignal';
import LoggedOut from '../../Logout/LoggedOut';
import { useMessageBus } from '../../MessageBus';
import ScrollToTop from '../../ScrollToTop';
import WhenApplicationSession from '../../Session/WhenApplicationSession';
import Tooling from '../../Tooling';
import IntercomGuestTooling from '../../Tooling/IntercomGuestTooling';
import { loader, TranslationsLoader } from '../../Translations';
import BrandLoader from '../BrandLoader';
import WhenRootResource from '../WhenRootResource';
import AppReactions from './AppReactions';
import AppView from './AppView';

const withErrorBoundary = (element: JSX.Element) => {
  return appsignal
    .map((instance: JSClient) => (
      <ErrorBoundary action="App" instance={instance}>
        {element}
      </ErrorBoundary>
    ))
    .getOrElse(() => element);
};

const router = createBrowserRouter([
  {
    path: '/logged-out',
    element: withErrorBoundary(
      <>
        <LoggedOut />
        <IntercomGuestTooling />
      </>,
    ),
  },
  {
    path: '*',
    element: withErrorBoundary(
      <>
        <ScrollToTop />
        <AppView />
      </>,
    ),
  },
]);

function App() {
  useMessageBus();

  return (
    <TranslationsLoader loader={loader('en')} loading={<BrandLoader />}>
      <WhenRootResource>
        <Tooling />
        <AppReactions />
        <WhenApplicationSession>
          <RouterProvider router={router} />
        </WhenApplicationSession>
      </WhenRootResource>
    </TranslationsLoader>
  );
}

export default App;
